'use client';

// Empty orphan shell — Market News UI removed; route kept for direct URL / deep-link compatibility.
const Page = () => null;

export default Page;
